import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hasAdminRole } from "../store/AclUtil";
import { useAuth } from "../store/auth/hooks";
import { useLicense } from "../store/license/hooks";

export const ProtectedRoute = ({ children }) => {
  const navigate = useNavigate();
  const { isAuthenticated, isLoaded: userIsLoaded, user } = useAuth();
  const { isLoaded: licenseIsLoaded, loadLicense, status } = useLicense();

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/login", { replace: true });
    } else if (licenseIsLoaded && !status.licenseValid && userIsLoaded) {
      if (hasAdminRole(user)) {
        navigate("/app/admin/license", { replace: true });
      } else {
        navigate("/app/licenseError", { replace: true });
      }
    }
  }, [isAuthenticated, licenseIsLoaded, status, userIsLoaded, navigate, user]);

  useEffect(() => {
    if (!licenseIsLoaded) loadLicense();
  }, [licenseIsLoaded, loadLicense]);

  return licenseIsLoaded ? children : null;
};
